// extracted by mini-css-extract-plugin
export default {"Container":"payroll_Container__WsB3J","section-1":"payroll_section-1__Dy6Zs","content":"payroll_content__+l8W3","section-2":"payroll_section-2__OADH1"};